// extracted by mini-css-extract-plugin
export default {"wrapper":"load_wrapper__MofUq","icon":"load_icon__J4101","clrtext":"load_clrtext__L6yew","nrtext":"load_nrtext__QKaot","text":"load_text__4-IMM"};